import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import AccountStatus from "./components/AccountStatus";
import GauntletsAccounts from "./components/GauntletsAccounts";
import AccountSimulators from "./components/AccountSimulators";

import { useAdminProviderDataContext } from "../../../../context";
import { ACCOUNTS_API_URLS } from "../../../../api/accounts";
import { customerActions } from "../../../../reducers/customer";
import { APIAccounts } from "../../../../api";
import { PaymentCards } from "../index";

const AccountManagement = (): React.ReactElement => {
  const params: { id: string } = useParams();
  const id = +params.id;
  const dispatch = useDispatch();
  const {
    user: {
      allowed_features: { change_customer_status, change_gauntlet_and_simulator_data },
    },
  } = useAdminProviderDataContext();

  const { isError, error } = useQuery({
    retry: false,
    queryKey: [ACCOUNTS_API_URLS.getAccountManagementData, id],
    async queryFn() {
      dispatch(customerActions.fetchManagementDataRequest());
      const response = await APIAccounts.getAccountManagementDataRequest(id);
      dispatch(customerActions.fetchManagementDataSuccess(response.data));
      return response;
    },
  });

  useEffect(() => {
    if (isError && error) {
      console.error("Error fetch account management data", error);
      dispatch(customerActions.fetchManagementDataFailed());
    }
  }, [isError, error]);

  return (
    <div>
      <Typography fontWeight={600}>Account management</Typography>

      <div>
        {change_customer_status && <AccountStatus />}
        {change_gauntlet_and_simulator_data && (
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <GauntletsAccounts />
            </Grid>
            <Grid item xs={6}>
              <AccountSimulators />
            </Grid>
          </Grid>
        )}
        <PaymentCards />
      </div>
    </div>
  );
};

export default AccountManagement;
